var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      class: {
        header: _vm.isHeader(),
        unindented: !_vm.recipeIngredientsHaveSubgroups,
      },
      on: { click: _vm.toggleDone },
    },
    [
      _c("div", { staticClass: "checkmark", class: { done: _vm.isDone } }, [
        _vm._v("✔"),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "ingredient",
        domProps: { innerHTML: _vm._s(_vm.displayIngredient) },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }